import React from 'react';

import {
  Breakpoints,
  TextAppearance,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';

import { CardsGroup, CardsWrapper, TitleContainer } from './styled';
import { DownloadCard } from './DownloadCard';
import { OwnersLiteratureDocumentsData } from '../../typings/general';

interface CardsContainerProps {
  apiConfig: string;
  title: string;
  subTitle: string;
  documentsData: OwnersLiteratureDocumentsData[];
  type?: string;
}

export const CardsContainer = ({
  apiConfig,
  title,
  subTitle,
  documentsData,
  type
}: CardsContainerProps) => {
  return (
    <CardsGroup>
      <TitleContainer>
        <TextCustom
          appearance={TextAppearance.headline300}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize20,
              fontWeight: TextWeight.light,
              lineHeight: TextLineHeight.TextLineHeight24,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize24,
              fontWeight: TextWeight.light,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
          }}
        >
          {title}
        </TextCustom>
        <TextCustom
          appearance={TextAppearance.headline300}
          tag={TextTag.p}
          style={{
            [Breakpoints.default]: {
              fontSize: TextSize.TextSize24,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight28,
            },
            [Breakpoints.b1600]: {
              fontSize: TextSize.TextSize32,
              fontWeight: TextWeight.bold,
              lineHeight: TextLineHeight.TextLineHeight36,
            },
          }}
        >
          {subTitle}
        </TextCustom>
      </TitleContainer>
      <CardsWrapper>
        {documentsData.map(
          (document: OwnersLiteratureDocumentsData, index: number) => (
            <DownloadCard
              doc={document}
              key={`${document.file_name}_${index + 1}`}
              type={type}
              apiConfig={apiConfig}
            />
          ),
        )}
      </CardsWrapper>
    </CardsGroup>
  );
};
